export default "__VITE_PUBLIC_ASSET__b3bf8a1b__"